import { Box, LinearProgress, Typography } from '@mui/material';
import { ReactElement } from 'react';

export interface ProgressStripProps {
  complete: boolean;
  progress: number;
}

export default function ProgressStrip({ progress, complete }: ProgressStripProps): ReactElement {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', padding: '6px', width: '100%' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress
          color={complete ? 'success' : 'primary'}
          sx={{ width: '100%' }}
          variant="determinate"
          value={progress}
        />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {`${Math.round(progress)}%`}
        </Typography>
      </Box>
    </Box>
  );
}
